import { Directive, ElementRef, HostListener, AfterContentInit, Input } from '@angular/core';

@Directive({
    selector: 'textarea[autoResize]',
})
export class AutoResizeDirective {
    @Input('autoResize') minHeight = 44;

    constructor(private elRef: ElementRef<HTMLTextAreaElement>) {}

    @HostListener('input')
    onInput(): void {
      this.adjust();
    }
  
    private adjust(): void {
        const el = this.elRef.nativeElement;
        el.style.height = 'auto';
        const border = el.offsetHeight - el.clientHeight;
        const newHeight = Math.max(this.minHeight, el.scrollHeight + border);
    
        el.style.height = `${newHeight}px`;
    }
}
